import { DataSource, Label, Layout, Panel, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutMultiSendLoadTender extends Layout {
    labelErrorCount: Label;
    labelErrors: Label;
    labelTotal: Label;
    labelTotalCount: Label;
    panelCounts: Panel;
    panelHeader: Panel;
    panelReady: Panel;
    panelTotal: Panel;
    sourceMultiPrepareTender: DataSource;
    sourceMultiSendTenders: DataSource;
    tableMultiSendLoadTender: Table;
    textboxAddContact: Textbox;
    textboxContact: Textbox;
    textboxMustRespondBy: Textbox;
}
